export default __webpack_public_path__ + "assets/favicon.bd44d24428f2dad311f25a94e22b614d.ico";